import { ColorModeScript } from '@chakra-ui/react';
import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import theme from './theme/Theme'

ReactDOM.render(
  <React.StrictMode>
  <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
